<div ng-bind-html="pdvCtrl.newdrug.indcriteria"></div>